module.exports = __webpack_public_path__ + "static/img/sushi.19633ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sushi.jpg
// module id = 6aIJ
// module chunks = 1